
import React from 'react';
import styled from 'styled-components';
import ScrollLaundry from  '../../components/ScrollLaundry/ScrollLaundry';
import ScrollMaskup from '../../components/ScrollMaskup/ScrollMaskup';
import ScrollEats from '../../components/ScrollEats/ScrollEats';
import ScrollOnthego from '../../components/ScrollOnthego/ScrollOnthego';
import ScrollVote from '../../components/ScrollVote/ScrollVote';
import {Link} from 'react-router-dom';

const Container = styled.div`
  display: flex;
  width: auto;
  height:auto;
  flex-wrap: nowrap;
  flex-direction: row;
  overflow-x: scroll;


  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
 }

`;

const Impactwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s; 
}
`;
const Space = styled.div`
  margin:0px;
  @media (max-width: 768px) {
    margin:7px;

  }
`;

class CarouselPicks extends React.Component {
  laundry= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('laundry');
        }
    maskup= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('mask up');
        }
    eats= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('expand your diet');
        }  
    onthego= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('on the go');
        }   
    vote= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('vote');
        }        
  render () {
   return (

  <Container>
    <Space/>
    <Impactwrapper><Link onClick={this.vote}><ScrollVote/></Link></Impactwrapper>  
    <Impactwrapper><Link onClick={this.maskup}><ScrollMaskup/></Link></Impactwrapper>
    <Impactwrapper><Link onClick={this.laundry}><ScrollLaundry/></Link></Impactwrapper>  
    <Impactwrapper><Link onClick={this.eats}><ScrollEats/></Link></Impactwrapper>
    <Impactwrapper><Link onClick={this.onthego}><ScrollOnthego/></Link></Impactwrapper>     
  </Container>
  );
 }
}
export default CarouselPicks;
